import type { MarketVariants } from '@/lib/i18n'

export type Slide7DefenseCopy = {
  eyebrow: string
  title: string
  body: string
}

export const copy: MarketVariants<Slide7DefenseCopy> = {
  US: {
    eyebrow: 'Remember',
    // "defense" -> "defence" auto-handled for GB / CA / AU by toMarketSpelling.
    title: "High emotion is the scammer's best friend.",
    body:
      'If a message makes your heart race or your mind spin, treat that feeling as a warning sign that someone may be trying to manipulate you.',
  },
  ar: {
    eyebrow: 'تذكّر',
    title: 'المشاعر القوية هي أفضل صديق للمحتال.',
    body:
      'إذا جعلتك رسالة ما تشعر بخفقان قلبك أو تشوّش ذهنك، فتعامل مع هذا الشعور على أنه علامة تحذير بأن أحدهم قد يحاول التلاعب بك.',
  },
}
